"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _inputCard = _interopRequireDefault(require("./input-card"));

var _linkCard = _interopRequireDefault(require("./link-card"));

// Track the amount of Option Card instantiated to keep ids unique
var optionCardInstances = 1;

var CommonOptionCard = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(CommonOptionCard, _React$Component);

  CommonOptionCard.resourceType = function resourceType() {
    return 'CommonOptionCard';
  };

  function CommonOptionCard(props) {
    var _this;

    _this = _React$Component.call(this, props) || this; // Generate unique ids for accessibility and usability

    var name = props.name ? String(props.name).replace(/\s/g, '') : '';
    _this.id = props.id || "common-option-card-" + optionCardInstances + name + "-id";
    _this.name = props.name || "common-option-card-" + optionCardInstances + "-name";
    optionCardInstances += 1;
    return _this;
  }

  var _proto = CommonOptionCard.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        type = _this$props.type,
        fullTap = _this$props.fullTap,
        label = _this$props.label,
        isSelected = _this$props.isSelected,
        onChange = _this$props.onChange,
        value = _this$props.value,
        classes = _this$props.classes,
        path = _this$props.path,
        theme = _this$props.theme,
        twoLineLabel = _this$props.twoLineLabel,
        disabled = _this$props.disabled;

    if (type === 'link') {
      return /*#__PURE__*/_react["default"].createElement(_linkCard["default"], {
        path: path,
        theme: theme
      }, children);
    }

    return /*#__PURE__*/_react["default"].createElement(_inputCard["default"], {
      type: type,
      fullTap: fullTap,
      label: label,
      isSelected: isSelected,
      onChange: onChange,
      value: value,
      classes: classes,
      theme: theme,
      cardId: this.id,
      cardName: this.name,
      twoLineLabel: twoLineLabel,
      disabled: disabled
    }, children);
  };

  return CommonOptionCard;
}(_react["default"].Component);

exports["default"] = CommonOptionCard;
CommonOptionCard.displayName = 'CommonOptionCard';
CommonOptionCard.defaultProps = {
  classes: [],
  fullTap: false,
  type: 'radio',
  twoLineLabel: false
};